import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScanPeriodRule } from '../../../../models/scan-testing.model';

// Configures a Scan Period rule: when the gate opens and closes, either as an
// offset from EP time (minutes) or a specific clock time (epoch seconds).
@Component({
  selector: 'app-sr-scan-period-modal',
  templateUrl: './sr-scan-period-modal.component.html',
  standalone: false,
  styleUrls: ['./sr-modal-shared.scss']
})
export class SrScanPeriodModalComponent implements OnInit {
  @Input() initial?: ScanPeriodRule;
  @Output() confirmed = new EventEmitter<ScanPeriodRule>();
  @Output() cancelled = new EventEmitter<void>();

  mode: 'offset' | 'specific' = 'offset';
  openValue = -720;  // -12h from EP by default
  closeValue = 720;  // +12h from EP by default

  ngOnInit(): void {
    if (this.initial) {
      this.mode = this.initial.mode;
      this.openValue = this.initial.openValue;
      this.closeValue = this.initial.closeValue;
    }
  }

  setMode(mode: 'offset' | 'specific'): void {
    if (mode === this.mode) { return; }
    this.mode = mode;
    // Reset to sensible defaults for the chosen mode.
    if (mode === 'offset') {
      this.openValue = -720;
      this.closeValue = 720;
    } else {
      this.openValue = 0;
      this.closeValue = 0;
    }
  }

  // Offset steppers move in 15-minute increments.
  stepOpen(deltaMins: number): void { this.openValue += deltaMins; }
  stepClose(deltaMins: number): void { this.closeValue += deltaMins; }

  offsetLabel(mins: number): string {
    const sign = mins < 0 ? '-' : '+';
    const abs = Math.abs(mins);
    const h = Math.floor(abs / 60);
    const m = abs % 60;
    return `${sign}${h}h ${m.toString().padStart(2, '0')}m`;
  }

  // Bridges the datetime-local input (local string) and stored epoch seconds.
  toDateTimeLocal(epochSeconds: number): string {
    if (!epochSeconds) { return ''; }
    const d = new Date(epochSeconds * 1000);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
      + `T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  setOpenDateTime(value: string): void {
    const ms = Date.parse(value);
    if (!Number.isNaN(ms)) { this.openValue = Math.round(ms / 1000); }
  }

  setCloseDateTime(value: string): void {
    const ms = Date.parse(value);
    if (!Number.isNaN(ms)) { this.closeValue = Math.round(ms / 1000); }
  }

  onConfirm(): void {
    this.confirmed.emit({
      type: 'scan_period',
      mode: this.mode,
      openValue: Number(this.openValue) || 0,
      closeValue: Number(this.closeValue) || 0
    });
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
